<template>
  <div class="dropdown" v-click-away="hideDropdown" :class="[ extraCssClass ]" v-cloak>
    <button type="button" class="dropdown__link link--no-hover" @click="toggleDropdown()" :class="{'dropdown__link--active' : show}">
      <span class="dropdown__selected">{{ selectedText }}</span>
      <i class="icon " :class="[ show ? 'icon--flipped' : '', iconClass ]"></i>
    </button>
    <transition name="fade">
      <div class="dropdown__holder" :class="{ 'dropdown__holder--mobile': applyMobileHeight }"  v-if="show" v-cloak>
        <ul class="dropdown__list">
          <li
            v-show="selectedOptionId !== 0"
            class="dropdown__list-item"
            :class="{ 'dropdown__list-item--active': selectedOptionId === 0 }"
          >
            <a class="dropdown__list-link" @click="selectOption(0)">
              {{ emptyString }}
            </a>
          </li>
          <li
            v-for="option in districts"
            class="dropdown__list-item"
            :class="{ 'dropdown__list-item--active': selectedOptionId === option.key }"
          >
            <a class="dropdown__list-link" @click="selectOption(option.key)">
              {{ option.value }}
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script setup>
import {ref, computed, watch, onBeforeMount} from 'vue'
import axios from 'axios'
import useFilterStore from '../../store/filterStore'

const props = defineProps({
  emptyString: {
    default: 'Select an option',
  },
  defaultSelectedId: {
    default: 0,
  },
  iconClass: {
    default: 'icon--down',
  },
  extraCssClass: {
    type: String,
  },
  defaultType: {
    default: 'village',
  },
  regionId: {
    default: 0,
  },
  eventType: {
    default: '',
  },
})

const show = ref(false);
const selectedOptionId = ref(parseInt(props.defaultSelectedId, 10));
let districts = ref(false);
const applyMobileHeight = ref(false);
const filterStore = useFilterStore()

const selectedText = computed(() => {
  if (districts.value === false) {
    return props.emptyString;
  }

  const selected = districts.value.find(opt => opt.key === selectedOptionId.value);
  return selected ? selected.value : props.emptyString;
});

const toggleDropdown = () => {
  if (districts.value.length > 0) {
    show.value = !show.value;

    if (show.value && window.innerHeight < 800) {
      applyMobileHeight.value = true;
    }
  }
};

const hideDropdown = () => {
  if (show.value) {
    show.value = false;
  }
};

const selectOption = (key) => {
  selectedOptionId.value = key;
  show.value = !show.value;
  filterStore.district = {
    id: 0,
    url: '',
  }

  filterStore.suburbs = []

  if (districts.value !== false) {
    const selected = districts.value.find(opt => opt.key === selectedOptionId.value);
    filterStore.district = {
      id: key,
      url: selected.url,
    };
  }

};

const fetchData = async (regionId) => {
  axios.get(`/api/districts?regionId=${regionId}&type=${props.defaultType}&eventType=${props.eventType}`).then((response) => {
    districts.value = response.data;

    if (selectedOptionId.value !== 0) {
      const selected = districts.value.find(opt => opt.key === selectedOptionId.value);
      filterStore.district = {
        id: selectedOptionId.value,
        url: selected.url,
      };
    }
  });
};

watch(
  () => filterStore.region,
  async (newRegion) => {
    await fetchData(newRegion.id);
  }
);

// watchEffect(() => {
//   console.log('watch effect')
//   districts.value = props.districtList;
//
//   if (selectedOptionId.value) {
//     const selected = districts.value.find(opt => opt.key === selectedOptionId.value);
//
//     if (selected !== undefined) {
//       filterStore.district = {
//         id: selectedOptionId.value,
//         url: selected.url,
//       };
//     }
//   }
// });

onBeforeMount(async () => {
  if (props.regionId) {
    await fetchData(props.regionId);
  }
});
</script>
